<template>
  <v-list subheader>
    <ConfirmDeleteDialog :item="itemToRemove"
      title="Remove product & bservice" @confirm-delete="remove" ref="confirmDialog"/>
    <template v-for="(item, idx) in items">
      <v-list-item :key="item.id"
        @click="$emit('load-detail', item)" class="dense-list-item"
        :style="'border-bottom:1px solid rgba(0,0,128,.2); background-color:' + (idx % 2 !== 0 ? 'rgba(0,60,128,.1)' : 'white')">
        <v-list-item-content>
          <v-list-item-title>
            <v-container style="padding-top:0; padding-bottom:0;">
              <v-row no-gutters>
                <v-col cols="11" sm="10">
                  {{ item.name }}
                </v-col>
                <v-col cols="1" sm="2">
                  <v-btn large icon @click.stop="confirmRemove(item)" color="red lighten-3" style="margin-top:-12px">
                    <v-icon>delete_outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-container style="padding-top:0; padding-bottom:0;">
              <v-row no-gutters>
                <v-col cols="3">${{ item.price }}</v-col>
                <v-col cols="3">GST {{ item.gst_percent }}%</v-col>
                <v-col cols="6">{{ item.description }}</v-col>
              </v-row>
            </v-container>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
  </v-list>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import EditForm from '@/components/public/EditForm'
import ProdServiceService from '@/services/ProdServiceService'
import ConfirmDeleteDialog from '@/components/dialog/ConfirmDeleteDialog'

@Component({
  components: {
    EditForm,
    ConfirmDeleteDialog
  }
})
export default class ProdService extends Vue {
  itemToRemove = null
  items = []
  entityId = null
  loading = false

  mounted () {
  }

  load (entityId) {
    this.entityId = entityId
    this.loading = true
    this.items = []
    return ProdServiceService.list(this.entityId)
      .then(resp => {
        this.items = resp.data.results || resp.data
      })
      .finally(() => {
        this.loading = false
      })
  }

  confirmRemove (item) {
    this.itemToRemove = item
    this.$refs.confirmDialog.open()
  }

  remove () {
    ProdServiceService.delete(this.itemToRemove.id)
      .then(() => {
        this.load(this.entityId)
      })
      .finally(() => {
        this.itemToRemove = null
        this.$refs.confirmDialog.close()
      })
  }

  showMessage () {
    alert('hello')
  }
}
</script>

<style lang="scss" scoped>
.dense-list-item {
  @media (max-width: 600px) {
    padding: 0 !important;
    margin-left: -8px;
    margin-right: -8px;
  }
}
</style>
